<template lang="pug">
  v-row
    v-col(cols="9")
      .gpt-settings-settings
        v-row.ma-0
          v-card(flat ).fill-width
            v-list-item(light).sdo-radius.grey.lighten-3.mb-4.py-2
              v-list-item-icon.mr-2.mt-3
                v-avatar(size="42" color="grey lighten-1")
                 v-icon(size="28" color="secondary") mdi-database
              v-list-item-content.pl-2
                v-list-item-title.text-body-2 База знаний:
                v-list-item-subtitle.text-body-1 {{ gptSettings.knowledgeBaseName }}
                //- .normal-wrap.mt-2.mb-1:  v-btn.ml-n2.pl-2(color="primary" text small) Перейти
                  v-icon(right) mdi-arrow-right
              v-list-item-icon.mt-1
                v-btn(
                  depressed color="primary"
                  :icon="$vuetify.breakpoint.mdAndDown"
                  @click="changeBaseKnowledge"
                  icon
                )
                  v-icon(size="28") mdi-pencil

        v-list-item-group(
          v-model="gptSettings.type"
          mandatory
          @change="gptSettings.handleSave()"
        )
          v-row.ma-0.pb-4
            v-col(
              v-for="(button, idx) in GPT_MODE_BUTTONS"
              v-bind="button.colProps"
              :key="idx"
            )
              v-list-item.sdo-radius.sdo-shadow.py-3.px-6(
                v-slot="{ active, toggle }"
                :color="`${button.color} lighten-3`"
                :value="button.value"
              )
                v-list-item-action.mr-5: v-icon(
                  size="34" :color="active ? button.color : 'secondary'"
                ) {{ button.icon }}
                v-list-item-content
                  .text-body-2.text--darken-1(
                    :class="active ? `${button.color}--text` : `grey--text`"
                  ): strong {{ button.text }}
        //- h2.pb-4.text-center: strong
        v-row.ma-0.justify-center.pb-4
          v-card(max-width="980" width="100%" flat )
            strong(v-if="units.length") Настройки нейросети для тем по отдельности:
            lazy-load(
              v-model="loadMore"
              @on-response="({ items }) => units.push(items)"
            )
              v-row(no-gutters).align-center.justify-center
                v-col(cols="12" md="12" lg="12")
                  v-list.transparent
                    GPTSettingsUnit.mb-4(
                      v-for="(unit, idx) in units"
                      :key="unit.id" filled
                      :idx="idx"
                      :type="gptSettings.type"
                      :baseKnowledgeId="gptSettings.knowledge_base_id"
                      :unit="unit"
                      :entityName="entity.name"
                    )
</template>
<script>
import GptSettings from '@/models/list/GptSettings';
import GPTSettingsUnit from './GPTSettingsUnit.vue';
import AutocompleateBaseKnowledge from './AutocompleateBaseKnowledge.vue';

export default {
  components: {
    GPTSettingsUnit,
  },
  // props: {
  //   // course: { type: Object, default: null },
  //   module: { type: Object, default: null },
  // },

  data() {
    return {
      gptSettings: {
        id: null,
        type: 0,
        knowledge_base_id: null,
      },
      loadMore: null,
      units: [],
    };
  },
  computed: {
    GPT_MODE_BUTTONS() {
      return [
        {
          color: 'error',
          colProps: { md: 12, lg: 4 },
          icon: 'mdi-close',
          text: 'Выключена',
          value: 0,
        },
        {
          color: 'primary',
          icon: 'mdi-book-open-page-variant-outline',
          text: 'Предлагает ответ',
          colProps: {},
          value: 2,
        },
        {
          colProps: {},
          color: 'primary',
          icon: 'mdi-bookshelf',
          text: 'Отвечает самостоятельно',
          value: 1,
        },

      ];
    },
    entity() {
      const entityTypes = {
        course: {
          entitySearchName: 'search[course_id]',
          settingsMethod: 'getCourseGptSettings',
          unitMethod: 'courseUnitIndex',
          service: 'courses',
          name: 'курса',
        },
        course_module: {
          entitySearchName: 'search[course_module_id]',
          settingsMethod: 'getModuleGptSettings',
          unitMethod: 'courseUnits',
          service: 'modules',
          name: 'модуля',
        },
      };
      return {
        id: Number(this.$route.params.id),
        type: this.$route.meta.type,
        ...entityTypes[this.$route.meta.type],
      };
    },
  },
  async created() {
    this.getGptSettings();
    this.getUnits();
  },
  methods: {
    changeBaseKnowledge() {
      this.$modals.show('form-controller', {
        title: 'Редактирование базы знаний',
        method: ({ data }) => {
          const { baseKnowledge } = data;
          this.gptSettings.setBaseKnowledge(baseKnowledge);
          return new Promise((resolve) => { resolve({ data: {} }); });
        },
        fields: [{
          component: AutocompleateBaseKnowledge,
          text: 'Выберите базу знаний',
          value: 'baseKnowledge',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        }],
      });
    },

    async getGptSettings() {
      const {
        entitySearchName, settingsMethod, id, type, service,
      } = this.entity;
      const params = {
        expand: 'course,course_unit,course_module',
        [entitySearchName]: id,
      };
      const { data } = await this.$api.gptPulse[settingsMethod](params);
      let gptSettings = {};
      if (data.data[0]) {
        [gptSettings] = data.data;
      } else {
        const { item } = await this.$api[service].show(id);
        gptSettings[type] = item;
      }
      this.gptSettings = new GptSettings(gptSettings, type);
    },
    async getUnits() {
      const { unitMethod, id, type } = this.entity;
      const params = {
        'search[is_modular]': Number(type === 'course_modules'),
      };
      const { items, loadMore } = await this.$api[this.entity.service][unitMethod](
        id,
        params, { hideErrorToasts: true },
      );
      this.loadMore = loadMore;
      this.units = items;
    },
  },
};
</script>
